import React, { useContext, useEffect, useMemo, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { GlobalContext } from "./context/GlobalContext";
import { showDangerMessage } from "./utils/notification.util";

const AdminRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(GlobalContext);
  const navigate = useNavigate();
  useMemo(() => {
    if (user?.uuid === '' || user?.role !== "admin") {
      navigate('/login');
    }
  }, [user]);
  return <Component {...rest} />;
};
export default AdminRoute;